import { useNotificationStore } from '@/stores/ui/notifications'

// DEVA-181: transaction/fetch answers 404 when the order has no transaction (its Zoho deal was
// never created). Every caller used to swallow that error, so the customer saw nothing happen.
export const TRANSACTION_NOT_FOUND_MESSAGE =
  'We could not prepare the payment for this booking. Please create the booking again or contact us.'

export const isTransactionNotFound = (error: unknown): boolean => {
  return (error as { response?: { status?: number } } | undefined)?.response?.status === 404
}

// Shows the message when the error is that 404. Returns true when it did, so the caller can
// keep its own handling for every other error.
export const notifyIfTransactionNotFound = (error: unknown): boolean => {
  if (!isTransactionNotFound(error)) {
    return false
  }
  useNotificationStore().showError(TRANSACTION_NOT_FOUND_MESSAGE)
  return true
}
